import { Map } from '@popety_io/popety-io-lib'
import { API_BASE_URL } from '../../../../../services'

const renderMethod = 'aggs'

const sourceName = 'es_mvt_company'
const fillStyle = 'layer_fill_company'

const removeCompanyTiles = ({ map }: { map: Map }) => {
  if (map.getSource(sourceName)) {
    map.removeLayer(fillStyle)
    map.removeSource(sourceName)
  }
}

const getCompanyTiles = ({
  map,
  indexName = 'statistics-point-enterprise-year',
  fieldOpt = 'total_employment',
  geometryFieldName = 'geo_center',
}: {
  map: Map
  indexName?: string
  geometryFieldName?: string
  fieldOpt?: string
}) => {
  try {
    if (map.getSource(sourceName)) {
      map.removeLayer(fillStyle)
      map.removeSource(sourceName)
    }

    map.addSource(sourceName, {
      type: 'vector',
      tiles: [
        `${API_BASE_URL}/public/entreprise/tiles?index=${indexName}&geometry=${geometryFieldName}&fieldOpt=${fieldOpt}&renderMethod=${renderMethod}&x={x}&y={y}&z={z}`,
      ],
      minzoom: 0,
      maxzoom: 24,
    })

    map.addLayer({
      id: fillStyle,
      type: 'fill',
      source: sourceName,
      'source-layer': 'hits',
      paint: {
        'fill-outline-color': 'rgba(0, 0, 0, 0)',
        'fill-opacity': 0.5,
      },
    })

    let colorExpression: any = {
      property: fieldOpt,
      default: '#f0f0f0',
      stops: [
        [0, '#C5D564'],
        [60, '#DAD14C'],
        [130, '#EECD34'],
        [200, '#FCC423'],
        [300, '#F9891A'],
        [400, '#F14C11'],
      ],
    }

    if (fieldOpt === 'total_establishments') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        stops: [
          [0, '#C5D564'],
          [20, '#DAD14C'],
          [40, '#EECD34'],
          [60, '#FCC423'],
          [80, '#F9891A'],
          [100, '#F14C11'],
        ],
      }
    }

    if (fieldOpt === 'total_employment_most_represented_sector') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        type: 'categorical',
        stops: [
          ['employment_sector_1', '#C5D564'],
          ['employment_sector_2', '#EECD34'],
          ['employment_sector_3', '#F9891A'],
        ],
      }
    }

    if (fieldOpt === 'total_establishments_most_represented_sector') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        type: 'categorical',
        stops: [
          ['establishments_sector_1', '#C5D564'],
          ['establishments_sector_2', '#EECD34'],
          ['establishments_sector_3', '#F9891A'],
        ],
      }
    }

    // Change the color
    map.setPaintProperty(fillStyle, 'fill-color', colorExpression)
  } catch (error) {
    console.error(error)
  }
}

export { removeCompanyTiles, getCompanyTiles }
